<template>
  <Transition
    enter-active-class="transition-opacity duration-150"
    leave-active-class="transition-opacity duration-150"
    enter-from-class="opacity-0"
    leave-to-class="opacity-0"
  >
    <div v-if="isVisible" data-testid="nav-overlay" class="nav-progress-overlay">
      <!-- Relative wrapper so the absolute label is centred over the ring -->
      <div class="nav-progress-ring-wrapper">
        <svg
          :width="SIZE"
          :height="SIZE"
          :viewBox="`0 0 ${SIZE} ${SIZE}`"
          class="-rotate-90"
          aria-hidden="true"
        >
          <!-- Track ring -->
          <circle
            :cx="SIZE / 2"
            :cy="SIZE / 2"
            :r="RADIUS"
            fill="none"
            stroke="#e5e7eb"
            :stroke-width="STROKE"
          />
          <!-- Progress ring -->
          <circle
            :cx="SIZE / 2"
            :cy="SIZE / 2"
            :r="RADIUS"
            fill="none"
            stroke="#96c748"
            :stroke-width="STROKE"
            stroke-linecap="round"
            :stroke-dasharray="circumference"
            :stroke-dashoffset="dashOffset"
            style="transition: stroke-dashoffset 0.1s linear"
          />
        </svg>
        <!-- Percentage label centred over the ring -->
        <span class="nav-progress-label"> {{ Math.round(navigationStore.progress) }}% </span>
      </div>
      <p class="nav-progress-message">Loading...</p>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, computed, watch, onUnmounted } from 'vue'
import { useNavigationStore } from '@/stores/navigation.store'

const RADIUS = 34
const STROKE = 6
const SIZE = (RADIUS + STROKE) * 2
const circumference = 2 * Math.PI * RADIUS

const navigationStore = useNavigationStore()

const isVisible = ref(false)
let hideTimer: ReturnType<typeof setTimeout> | null = null

const dashOffset = computed(() => circumference * (1 - navigationStore.progress / 100))

watch(
  () => navigationStore.isNavigating,
  navigating => {
    if (navigating) {
      if (hideTimer !== null) {
        clearTimeout(hideTimer)
        hideTimer = null
      }
      isVisible.value = true
    } else {
      // Brief pause to show 100% before fading out — short enough to avoid overlap with page spinners
      hideTimer = setTimeout(() => {
        isVisible.value = false
      }, 150)
    }
  }
)

onUnmounted(() => {
  if (hideTimer !== null) clearTimeout(hideTimer)
})
</script>
